<template>
  <router-link
    :to="{
      name: 'market-details',
      params: { marketId: market.marketId, marketUrl: market.marketUrl },
    }"
    :class="classModifiers"
    @click="fireMarketTileClick"
  >
    <div @mouseover="onMouseOver" @mouseleave="onMouseLeave" class="market-list-item-v2__container">
      <div class="market-list-item-v2__container-bg1" :style="styleModifiers"></div>
      <div class="market-list-item-v2__container-bg2"></div>
      <div class="market-list-item-v2__main-section">
        <div class="market-list-item-v2__main-section-container">
          <h3 class="market-list-item-v2__title">
            {{ market.marketName }}
          </h3>
          <div class="market-list-item-v2__contracts">
            <market-contract
              v-for="item in contracts"
              :market="market"
              :contract="item"
              :key="contractKey(item)"
            >
            </market-contract>
          </div>
          <div class="market-list-item-v2__shares">
            <span v-if="!showVolume" class="market-list-item-v2__shares-new"> NEW </span>
            <template v-else>
              <span v-large-number="totalSharesTraded"></span> Share<span
                v-if="totalSharesTraded !== 1"
                >s</span
              >
              Traded
            </template>
          </div>
        </div>
      </div>
      <div class="market-list-item-v2__right" v-if="watchIcon">
        <div class="market-list-item-v2__watch" @click.prevent.stop="watchToggle">
          <div class="market-list-item-v2__watch-icon"></div>
        </div>
      </div>
      <template v-if="showSharesOwnedNotification">
        <div class="market-list-item-v2__shares-owned"></div>
      </template>
    </div>
  </router-link>
</template>

<script src="./market-list-item-v2.js"></script>
<style src="./market-list-item-v2.scss" lang="scss"></style>
